import ecgsMenuIcon from "../assets/nav/menu_ecg.svg";
import manageMenuIcon from "../assets/nav/menu_management.svg";
import ordersMenuIcon from "../assets/nav/menu_orders.svg";
import reportsMenuIcon from "../assets/nav/menu_reports.svg";
import settingsMenuIcon from "../assets/nav/menu_settings.svg";
import { RouteConstants as Routes } from "../constants";
import { EcgsTableContextProvider } from "../context/EcgsTableContext";
import { Permissions } from "../models/permission";
import Role from "../models/role";
import IRoute from "../models/route.interface";
import { OrgType } from "../models/users.interface";
import EcgsPage from "../pages/EcgsPage";
import LimitedPage from "../pages/LimitedPage/LimitedPage";
import ManagementPage from "../pages/ManagementPage/ManagementPage";
import NotFoundPage from "../pages/NotFoundPage";
import OrdersPage from "../pages/OrdersPage/OrdersPage";
import ReportsPage from "../pages/ReportsPage/ReportsPage";
import SettingsPage from "../pages/SettingsPage/SettingsPage";
import authorizationService from "../services/authorization.service";

export const mainRoutes: IRoute[] = [
  // Will be added in the future
  // {
  //   id: Routes.PATIENTS,
  //   path: Routes.PATIENTS_PATH,
  //   linkLabel: "NAV.PATIENTS",
  //   component: <DashboardPage />,
  // },
  {
    id: Routes.ECGS,
    path: Routes.ECGS_PATH,
    link: {
      text: "NAV.ECGS",
      icon: ecgsMenuIcon,
    },
    component: (
      <EcgsTableContextProvider>
        <EcgsPage />
      </EcgsTableContextProvider>
    ),
    appScopes: ["uniqueId"],
    authorizedRoles: [
      Role.Reviewer,
      Role.OrgProfessional,
      Role.Professional,
      Role.OrgAdmin,
      Role.Consultant,
    ],
    permissions: (userRole: Role) => {
      return authorizationService.hasRole(userRole, [
        Role.OrgProfessional,
        Role.Professional,
        Role.OrgAdmin,
        Role.Consultant,
      ])
        ? [Permissions.CanViewEcgs]
        : undefined;
    },
  },
  {
    id: Routes.ECG_DETAILS,
    path: Routes.ECG_DETAILS_PATH,
    component: (
      <EcgsTableContextProvider>
        <EcgsPage />
      </EcgsTableContextProvider>
    ),
    appScopes: ["uniqueId"],
    authorizedRoles: [
      Role.Reviewer,
      Role.OrgProfessional,
      Role.Professional,
      Role.OrgAdmin,
      Role.Consultant,
    ],
    permissions: (userRole: Role) => {
      return authorizationService.hasRole(userRole, [
        Role.OrgProfessional,
        Role.Professional,
        Role.OrgAdmin,
        Role.Consultant,
      ])
        ? [Permissions.CanViewEcgs]
        : undefined;
    },
  },
  {
    id: Routes.REPORTS,
    path: Routes.REPORTS_PATH,
    component: <ReportsPage />,
    authorizedRoles: [
      Role.OrgAdmin,
      Role.OrgProfessional,
      Role.Professional,
      Role.Reviewer,
    ],
    permissions: () => [Permissions.CanViewReports],
    link: {
      text: "NAV.REPORTS",
      icon: reportsMenuIcon,
    },
  },
  {
    id: Routes.MANAGEMENT,
    path: Routes.MANAGEMENT_PATH,
    authorizedRoles: [Role.OrgAdmin, Role.OrgProfessional, Role.Reviewer],
    permissions: (userRole: Role) => {
      return !authorizationService.hasRole(userRole, [Role.OrgAdmin])
        ? [[Permissions.CanManageNonProUsers], [Permissions.CanManageProUsers]]
        : undefined;
    },
    link: {
      icon: manageMenuIcon,
      text: "NAV.MANAGE",
    },
    component: <ManagementPage />,
  },
  {
    id: Routes.SETTINGS,
    path: Routes.SETTINGS_PATH,
    link: {
      icon: settingsMenuIcon,
      text: "NAV.SETTINGS",
    },
    component: <SettingsPage />,
  },
  {
    id: Routes.ORDERS,
    path: Routes.ORDERS_PATH,
    authorizedRoles: [Role.OrgProfessional],
    authorizedOrgTypes: [OrgType.CRO],
    excludedPermissions: [Permissions.CanApproveEcg],
    link: {
      icon: ordersMenuIcon,
      text: "NAV.ORDERS",
    },
    component: <OrdersPage />,
  },
  {
    id: Routes.LIMITED,
    path: Routes.LIMITED_PATH,
    component: <LimitedPage />,
  },
  {
    id: "not_found",
    path: `*`,
    component: <NotFoundPage />,
  },
];
